import moment, { Moment } from 'moment';
import { fromPairs, union } from 'ramda';

export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

const default_order: DayOfWeek[] = [
  DayOfWeek.Sunday,
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
];

const _days = (start: DayOfWeek): DayOfWeek[] =>
  union(
    default_order.filter((_, i) => i >= default_order.indexOf(start)),
    default_order.filter((_, i) => i < default_order.indexOf(start)),
  );

type DayOfWeekLookup = { [D in DayOfWeek]: DayOfWeek[] };
const _ordered = fromPairs(
  default_order.map((x) => [x, _days(x)]),
) as DayOfWeekLookup;

export const days = (start = DayOfWeek.Monday): DayOfWeek[] => _ordered[start];

export const date = (day: DayOfWeek, reference?: Moment): Moment =>
  (reference ?? moment()).day(default_order.indexOf(day));

export const getStartOfWeek = (dayOfWeek, currDay): Moment => {
  if (currDay.format('dddd') === DayOfWeek.Sunday) {
    return currDay.subtract(6, 'days');
  }

  return date(dayOfWeek, currDay);
};
